<template>
  <div>
    <div
      v-if="isParagraphArrayOfString"
      :class="pDistance ? 'mb-5' : 'mb-0'"
    >
      <p
        v-for="(p, i) in paragraph"
        :key="i"
        class="article-text mb-0"
        :class="pItemDistance && i !== paragraph.length-1 ? 'mb-5' : 'mb-0'"
      >
        {{ p }}
      </p>
    </div>
    <div v-else>
      <div
        v-for="(p, i) in paragraph"
        :key="i"
        class="text-primary l-s-0_08 l-h-30 grey-dark"
        :class="pItemDistance && i !== paragraph.length-1 ? 'mb-5' : 'mb-0'"
      >
        <p
          class="font-weight-bold"
          :class="isContextIsArray ? 'mb-0' : 'mb-3'"
        >
          {{ p.title }}
        </p>
        <p v-if="isContextIsArray">
          {{ p.context }}
        </p>
        <div v-else>
          <p
            v-for="(c, idx) in p.context"
            :key="idx"
            class="text-primary l-s-0_08 l-h-30 grey-dark"
            :class="pItemDistance && i !== p.context-1 ? 'mb-2' : 'mb-0'"
          >
            {{ c }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Paragraph',
  props: {
    paragraph: {
      type: Array,
      default: () => [],
    },
    pDistance: {
      type: Boolean,
      default: false,
    },
    pItemDistance: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isParagraphArrayOfString() {
      return typeof this.paragraph[0] === 'string';
    },
    isContextIsArray() {
      return typeof this.paragraph[0].context === 'string';
    },
  },
};
</script>
